// extracted by extract-css-chunks-webpack-plugin
module.exports = {"form":"PasswordReset-f6535e6c930f5da2","submitButton":"PasswordReset-d6c8096925bcaf43"};